import { render, staticRenderFns } from "./AvitoRegistration.vue?vue&type=template&id=6e819987&"
import script from "./AvitoRegistration.vue?vue&type=script&lang=js&"
export * from "./AvitoRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports